import { questionGroupsService } from '../service'

export const groups = {
  state: {
    items: [],
    currentGroup: null,
    loading: false
  },
  mutations: {
    SET_ITEMS (s, v) {
      s.items = v
    },
    SET_CURRENT_GROUP (s, v) {
      s.currentGroup = v
    },
    SET_LOADING (s, v) {
      s.loading = v
    },
    ADD_GROUP (s, group) {
      s.items.push(group)
    },
    UPDATE_GROUP (s, updatedGroup) {
      const index = s.items.findIndex(item => item.id === updatedGroup.id)
      if (index !== -1) {
        s.items.splice(index, 1, updatedGroup)
      }
    },
    REMOVE_GROUP (s, groupId) {
      s.items = s.items.filter(item => item.id !== groupId)
    }
  },
  getters: {
    getGroupById: state => id => {
      return state.items.find(group => group.id === id)
    }
  },
  actions: {
    getGroups ({ commit }) {
      commit('SET_LOADING', true)
      return questionGroupsService.getGroupList()
        .then((resp) => {
          commit('SET_ITEMS', resp.data)
          commit('SET_LOADING', false)
          return resp.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          throw error
        })
    },
    getGroup ({ commit }, groupId) {
      commit('SET_LOADING', true)
      return questionGroupsService.getGroup(groupId)
        .then((resp) => {
          commit('SET_CURRENT_GROUP', resp.data)
          commit('SET_LOADING', false)
          return resp.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          throw error
        })
    },
    createGroup ({ commit }, groupData) {
      commit('SET_LOADING', true)
      return questionGroupsService.createGroup(groupData)
        .then((resp) => {
          commit('ADD_GROUP', resp.data)
          commit('SET_LOADING', false)
          return resp.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          throw error
        })
    },
    updateGroup ({ commit }, { groupId, data }) {
      commit('SET_LOADING', true)
      return questionGroupsService.updateGroup(groupId, data)
        .then((resp) => {
          commit('UPDATE_GROUP', resp.data)
          commit('SET_LOADING', false)
          return resp.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          throw error
        })
    },
    deleteGroup ({ commit }, groupId) {
      commit('SET_LOADING', true)
      return questionGroupsService.deleteGroup(groupId)
        .then(() => {
          commit('REMOVE_GROUP', groupId)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('SET_LOADING', false)
          throw error
        })
    }
  },
  namespaced: true
}
